<template lang='pug'>
  v-combobox(
    ref='branchSelect'
    :value='value'
    @input='update'
    @change='closeMenu'
    :rules='rules'
    :items='items'
    :search-input.sync='search'
    hide-selected
    :label='label'
    chips
    deletable-chips
    :persistent-hint='!!customMessage'
    :hint='customMessage'
    hide-no-data
    small-chips)
</template>

<script>
import GitHub from '../api/github';

export default {
  name: 'SelectBranch',
  async mounted() {
    await this.load();
  },
  props: {
    label: {
      default() {
        return 'Branch Filter';
      }
    },
    customMessage: {
      type: String
    },
    value: {
      default() {
        return [];
      }
    },
    rules: {
      type: Array
    }
  },
  methods: {
    async load() {
      if (this.loading) return; // already loading
      if (this.items && this.items.length) return; // already loaded
      try {
        this.loading = true;
        this.items = await GitHub.branches();
        this.$emit('branchesLoaded', this.items);
      } catch (e) {
        console.error(`Error loading branches: ${e}`);
        throw e;
      } finally {
        this.loading = false;
      }
    },
    update(value) {
      this.$emit('input', value);
    },
    closeMenu() {
      this.$refs.branchSelect.isMenuActive = false;
    }
  },
  data() {
    return {
      items: [],
      search: null,
      loading: false
    };
  }
};
</script>

<style scoped>

</style>
